import type { CSSProperties } from 'react';
import type { ElementType } from 'react';
import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

interface SpacerProps {
  as?: ElementType;
  display?: CSSProperties['display'];
  height?: number;
  width?: number;
}

const StyledSpacer = styled(Box)<
  Pick<SpacerProps, 'display' | 'width' | 'height'>
>`
  ${({ display, height, width }) => css`
    display: ${display};
    height: ${height}px;
    width: ${width}px;
  `}
`;

export const Spacer = ({
  as = 'div',
  display = 'inline-block',
  height = 5,
  width = 0,
}: SpacerProps) => (
  <StyledSpacer as={as} display={display} height={height} width={width}>
    {'\u00A0'}
  </StyledSpacer>
);
